/**
 * Whether the viewer has anything under "Forms" (forms card 11): the catalog has a type they may
 * submit, process or see the whole queue of. The sidebar shows its Forms item on this; the
 * /forms page itself needs no gate (its inbox and My forms read only what the API lets the
 * caller see).
 */
import { useFormsCatalogSummary, useFormsManage } from '@/api/extensions/forms/useForms';
import { useAuth } from '@/contexts/AuthContext';
import { seesFormQueue } from './formDisplay';

export function useCanSeeForms(): boolean {
  const catalog = useFormsCatalogSummary();
  return (catalog.data ?? []).some((t) => t.can_submit || t.can_process || seesFormQueue(t.capabilities));
}

/** Whether the viewer may start some form (Forms+ 08): the sidebar's "Start a form" (/forms/start). */
export function useCanStartForms(): boolean {
  const catalog = useFormsCatalogSummary();
  return (catalog.data ?? []).some((t) => t.can_submit);
}

/**
 * Whether the viewer has Settings → Forms (card 13): an admin, or MANAGE on some type (GET
 * /forms/types lists one). The Settings card and the /settings/forms route show on this; the API
 * decides every call itself.
 */
export function useCanManageForms(): { canManage: boolean; isLoading: boolean } {
  const { isAdmin } = useAuth();
  const admin = isAdmin();
  const manage = useFormsManage({ enabled: !admin });
  return { canManage: admin || (manage.data?.types.length ?? 0) > 0, isLoading: !admin && manage.isLoading };
}
